export enum PaymentMethod {
    EASY_PAY = 1,
}
